var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNotMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 56H21.8333C20.4188 56 19.0623 55.4381 18.0621 54.4379C17.0619 53.4377 16.5 52.0812 16.5 50.6667V13.3333C16.5 11.9188 17.0619 10.5623 18.0621 9.5621C19.0623 8.5619 20.4188 8 21.8333 8H43.1667C44.5812 8 45.9377 8.5619 46.9379 9.5621C47.9381 10.5623 48.5 11.9188 48.5 13.3333V32M29.8333 10.6667H35.1667M32.5 45.3333V45.36",
    stroke: "#ED3241",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.167 42.6665V50.6665M51.167 58.6665V58.6932",
    stroke: "#FFBB00",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotMobile);
export default __webpack_public_path__ + "static/media/ic_not_mobile.17b3732320b907670de22dafe01deadb.svg";
export { ForwardRef as ReactComponent };